// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"e337b81c","72":"eff3689d","477":"27357e1c","627":"ea420c2e","663":"9fa3d090","667":"5f664457","777":"bbf341a0","803":"788cab22","820":"0f793135"}[chunkId] + ".chunk.js";
};